"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITimePicker = _interopRequireDefault(require("UIComponents/input/UITimePicker"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UICheckbox = _interopRequireDefault(require("UIComponents/input/UICheckbox"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIDatePicker = _interopRequireDefault(require("UIComponents/input/UIDatePicker"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var SimpleDate = _interopRequireWildcard(require("UIComponents/core/SimpleDate"));

var _groupsToSelectOpts = _interopRequireDefault(require("timezone-utils/utils/groupsToSelectOpts"));

var _getTimezoneGroups = _interopRequireDefault(require("timezone-utils/utils/getTimezoneGroups"));

var _RichTextEditor = _interopRequireDefault(require("lead-flows-ui/components/common/RichTextEditor"));

var _SimpleTextInputWithValidation = _interopRequireDefault(require("lead-flows-ui/components/common/SimpleTextInputWithValidation"));

var _ValidationUtils = require("lead-flows-ui/utils/ValidationUtils");

var MAX_LENGTH_TITLE = 100;
var MAX_LENGTH_LOCATION = 100;
var MAX_LENGTH_DETAILS = 1000;
var TIMEPICKER_INTERVAL = 15;
var DEFAULT_INTERVAL = 60;
var DEFAULT_STARTTIME = 9 * 60;
var DEFAULT_ENDTIME = 10 * 60;
var MINUTES_PER_DAY = 24 * 60;
var FALLBACK_TIMEZONE = 'Europe/Belfast';

var EventSelector =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(EventSelector, _PureComponent);
  (0, _createClass2.default)(EventSelector, [{
    key: "langKey",
    value: function langKey(suffix) {
      return "leadFlowEditor.leadFlowThankYouMessage.calendar." + suffix;
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        addValidationError: _react.default.PropTypes.func.isRequired,
        removeValidationError: _react.default.PropTypes.func.isRequired,
        updateDyno: _react.default.PropTypes.func.isRequired,
        validation: _react.default.PropTypes.object.isRequired,
        redirectUrl: _react.default.PropTypes.string,
        eventTitle: _react.default.PropTypes.string,
        eventDetails: _react.default.PropTypes.string,
        eventLocation: _react.default.PropTypes.string,
        eventDates: _react.default.PropTypes.object,
        allGates: _react.default.PropTypes.array
      };
    }
  }]);

  function EventSelector(props) {
    var _this;

    (0, _classCallCheck2.default)(this, EventSelector);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(EventSelector).call(this, props));
    _this.state = (0, _extends2.default)({}, _this.deriveDatesFromProps(props));
    _this.handleFullDayChange = _this.handleFullDayChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleLocationChange = _this.handleLocationChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTitledChange = _this.handleTitledChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleDetailsChange = _this.handleDetailsChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTitleBlur = _this.handleTitleBlur.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleStartDateChange = _this.handleStartDateChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEndDateChange = _this.handleEndDateChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleEndTimeChange = _this.handleEndTimeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleStartTimeChange = _this.handleStartTimeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleTimeZoneChange = _this.handleTimeZoneChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(EventSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          updateDyno = _this$props.updateDyno,
          eventDates = _this$props.eventDates,
          addValidationError = _this$props.addValidationError,
          eventTitle = _this$props.eventTitle;
      var dates = eventDates || this.getDefaultDates();
      var defaultTimezone = dates.timezone === FALLBACK_TIMEZONE ? this.getDefaultTimezone() : dates.timezone;

      var startOffset = _I18n.default.moment.tz.zone(defaultTimezone).parse(dates.start);

      var endOffset = _I18n.default.moment.tz.zone(defaultTimezone).parse(dates.end);

      updateDyno({
        eventDates: (0, _extends2.default)({}, dates, {
          startWithTimezoneOffset: _I18n.default.moment.utc(dates.start).add(startOffset, 'minutes').valueOf(),
          endWithTimezoneOffset: _I18n.default.moment.utc(dates.end).add(endOffset, 'minutes').valueOf(),
          timezone: defaultTimezone
        })
      });

      if (!eventTitle) {
        addValidationError('eventTitleState', this.langKey('error.titleRequired'));
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState(this.deriveDatesFromProps(nextProps));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var removeValidationError = this.props.removeValidationError;
      removeValidationError('eventTitleState');
    }
  }, {
    key: "deriveDatesFromProps",
    value: function deriveDatesFromProps(props) {
      var _ref = props.eventDates || this.getDefaultDates(),
          start = _ref.start,
          end = _ref.end,
          timezone = _ref.timezone,
          fullDay = _ref.fullDay;

      var midnightStart = _I18n.default.moment.utc(start).startOf('day');

      var midnightEnd = _I18n.default.moment.utc(end).startOf('day');

      return {
        eventDates: {
          startDate: SimpleDate.fromMoment(_I18n.default.moment.utc(start)),
          endDate: SimpleDate.fromMoment(_I18n.default.moment.utc(end)),
          startTime: _I18n.default.moment.utc(start).diff(midnightStart, 'minutes'),
          endTime: _I18n.default.moment.utc(end).diff(midnightEnd, 'minutes'),
          timezone: timezone,
          fullDay: fullDay
        }
      };
    }
  }, {
    key: "getDefaultDates",
    value: function getDefaultDates() {
      var start = _I18n.default.moment.utc().startOf('day').add(DEFAULT_STARTTIME, 'minutes').valueOf();

      var end = _I18n.default.moment.utc().startOf('day').add(DEFAULT_ENDTIME, 'minutes').valueOf();

      var startOffset = _I18n.default.moment.tz.zone(FALLBACK_TIMEZONE).parse(start);

      var endOffset = _I18n.default.moment.tz.zone(FALLBACK_TIMEZONE).parse(end);

      return {
        start: start,
        end: end,
        startWithTimezoneOffset: _I18n.default.moment.utc(start).add(startOffset, 'minutes').valueOf(),
        endWithTimezoneOffset: _I18n.default.moment.utc(end).add(endOffset, 'minutes').valueOf(),
        timezone: FALLBACK_TIMEZONE,
        fullDay: false
      };
    }
  }, {
    key: "updateDynoDate",
    value: function updateDynoDate(_ref2) {
      var dates = _ref2.eventDates;
      var updateDyno = this.props.updateDyno;
      var start = SimpleDate.toMomentUTC(dates.startDate).add(dates.startTime, 'minutes').valueOf();
      var end = SimpleDate.toMomentUTC(dates.endDate).add(dates.endTime, 'minutes').valueOf();
      var updated = {
        fullDay: dates.fullDay,
        start: start,
        end: end,
        startWithTimezoneOffset: _I18n.default.moment.tz(dates.startDate, dates.timezone).add(dates.startTime, 'minutes').valueOf(),
        endWithTimezoneOffset: _I18n.default.moment.tz(dates.endDate, dates.timezone).add(dates.endTime, 'minutes').valueOf(),
        timezone: dates.timezone
      };
      this.setState({
        eventDates: dates
      });
      updateDyno({
        eventDates: updated
      });
    }
  }, {
    key: "handleTitledChange",
    value: function handleTitledChange(_ref3) {
      var value = _ref3.target.value;
      var _this$props2 = this.props,
          addValidationError = _this$props2.addValidationError,
          removeValidationError = _this$props2.removeValidationError,
          updateDyno = _this$props2.updateDyno;

      if (value.length > MAX_LENGTH_TITLE) {
        addValidationError('eventTitleState', this.langKey('error.titleTooLongWarning'));
      } else {
        removeValidationError('eventTitleState');
        updateDyno({
          eventTitle: value
        });
      }
    }
  }, {
    key: "handleTitleBlur",
    value: function handleTitleBlur(_ref4) {
      var value = _ref4.target.value;
      var _this$props3 = this.props,
          addValidationError = _this$props3.addValidationError,
          removeValidationError = _this$props3.removeValidationError;

      if (!value.length) {
        addValidationError('eventTitleState', this.langKey('error.titleRequired'));
      } else {
        removeValidationError('eventTitleState');
      }
    }
  }, {
    key: "handleDetailsChange",
    value: function handleDetailsChange(value) {
      var _this$props4 = this.props,
          addValidationError = _this$props4.addValidationError,
          removeValidationError = _this$props4.removeValidationError,
          updateDyno = _this$props4.updateDyno;

      if (value.plainText.length > MAX_LENGTH_DETAILS) {
        addValidationError('eventDetailsState', this.langKey('error.detailsTooLongWarning'));
      } else {
        removeValidationError('eventDetailsState');
        updateDyno({
          eventDetails: value.html
        });
      }
    }
  }, {
    key: "handleLocationChange",
    value: function handleLocationChange(_ref5) {
      var value = _ref5.target.value;
      var _this$props5 = this.props,
          addValidationError = _this$props5.addValidationError,
          removeValidationError = _this$props5.removeValidationError,
          updateDyno = _this$props5.updateDyno;

      if (value.length > MAX_LENGTH_LOCATION) {
        addValidationError('eventLocationState', this.langKey('error.locationTooLongWarning'));
      } else {
        removeValidationError('eventLocationState');
        updateDyno({
          eventLocation: value
        });
      }
    }
  }, {
    key: "handleEventTitleChange",
    value: function handleEventTitleChange(_ref6) {
      var value = _ref6.target.value;
      return value;
    }
  }, {
    key: "isValidTimeRange",
    value: function isValidTimeRange(dates) {
      var _this$state$eventDate = (0, _extends2.default)({}, this.state.eventDates, dates),
          startDate = _this$state$eventDate.startDate,
          endDate = _this$state$eventDate.endDate,
          startTime = _this$state$eventDate.startTime,
          endTime = _this$state$eventDate.endTime,
          fullDay = _this$state$eventDate.fullDay;

      if (fullDay) return true;

      if (startTime < 0 || endTime < 0 || startTime > MINUTES_PER_DAY - TIMEPICKER_INTERVAL || endTime > MINUTES_PER_DAY - TIMEPICKER_INTERVAL) {
        return false;
      }

      if (!SimpleDate.equals(startDate, endDate)) return true;
      return endTime > startTime;
    }
  }, {
    key: "handleDynoDateChange",
    value: function handleDynoDateChange(property) {
      var eventDates = this.state.eventDates;
      var newDates = (0, _extends2.default)({}, eventDates, property);
      var corrected = this.maybeCorrectEventDates(newDates);
      this.validateDates(corrected);
      this.updateDynoDate({
        eventDates: corrected
      });
    }
  }, {
    key: "maybeCorrectEventDates",
    value: function maybeCorrectEventDates(dates) {
      var corrected = this.maybeCorrectDates(dates);
      corrected = this.maybeCorrectTimes(corrected);
      return corrected;
    }
  }, {
    key: "maybeCorrectDates",
    value: function maybeCorrectDates(dates) {
      var startDate = dates.startDate,
          endDate = dates.endDate;

      if (SimpleDate.isValidRange({
        startDate: startDate,
        endDate: endDate
      })) {
        return dates;
      }

      return (0, _extends2.default)({}, dates, {
        endDate: startDate
      });
    }
  }, {
    key: "maybeCorrectTimes",
    value: function maybeCorrectTimes(dates) {
      if (this.isValidTimeRange(dates)) {
        return dates;
      }

      var defaultInterval = (0, _extends2.default)({}, dates, {
        endTime: dates.startTime + DEFAULT_INTERVAL
      });

      if (this.isValidTimeRange(defaultInterval)) {
        return defaultInterval;
      }

      var timepickerInterval = (0, _extends2.default)({}, dates, {
        endTime: dates.startTime + TIMEPICKER_INTERVAL
      });

      if (this.isValidTimeRange(timepickerInterval)) {
        return timepickerInterval;
      }

      var resetToDefault = (0, _extends2.default)({}, dates, {
        startTime: DEFAULT_STARTTIME,
        endTime: DEFAULT_ENDTIME
      });
      return resetToDefault;
    }
  }, {
    key: "validateDates",
    value: function validateDates(dates) {
      var _this$props6 = this.props,
          addValidationError = _this$props6.addValidationError,
          removeValidationError = _this$props6.removeValidationError;
      var startDate = dates.startDate,
          endDate = dates.endDate;

      if (!SimpleDate.isValidRange({
        startDate: startDate,
        endDate: endDate
      })) {
        addValidationError('dateState', this.langKey('error.invalidDate'));
        return;
      }

      if (!this.isValidTimeRange(dates)) {
        addValidationError('dateState', this.langKey('error.invalidDate'));
        return;
      }

      removeValidationError('dateState');
    }
  }, {
    key: "handleFullDayChange",
    value: function handleFullDayChange(_ref7) {
      var checked = _ref7.target.checked;

      if (checked) {
        this.handleDynoDateChange({
          fullDay: checked,
          startTime: 0,
          endTime: MINUTES_PER_DAY - TIMEPICKER_INTERVAL
        });
      } else {
        this.handleDynoDateChange({
          fullDay: checked
        });
      }
    }
  }, {
    key: "handleStartDateChange",
    value: function handleStartDateChange(_ref8) {
      var value = _ref8.target.value;
      this.handleDynoDateChange({
        startDate: value
      });
    }
  }, {
    key: "handleEndDateChange",
    value: function handleEndDateChange(_ref9) {
      var value = _ref9.target.value;
      this.handleDynoDateChange({
        endDate: value
      });
    }
  }, {
    key: "handleStartTimeChange",
    value: function handleStartTimeChange(_ref10) {
      var value = _ref10.target.value;
      this.handleDynoDateChange({
        startTime: value
      });
    }
  }, {
    key: "handleEndTimeChange",
    value: function handleEndTimeChange(_ref11) {
      var value = _ref11.target.value;
      this.handleDynoDateChange({
        endTime: value
      });
    }
  }, {
    key: "handleTimeZoneChange",
    value: function handleTimeZoneChange(_ref12) {
      var value = _ref12.target.value;

      if (!_I18n.default.moment.tz.zone(value)) {
        return;
      }

      this.handleDynoDateChange({
        timezone: value
      });
    }
  }, {
    key: "getDefaultTimezone",
    value: function getDefaultTimezone() {
      return (0, _getTimezoneGroups.default)().resolve(_I18n.default.moment.tz.guess(), FALLBACK_TIMEZONE);
    }
  }, {
    key: "getTimePickerMaxValue",
    value: function getTimePickerMaxValue() {
      var _this$state$eventDate2 = this.state.eventDates,
          fullDay = _this$state$eventDate2.fullDay,
          startDate = _this$state$eventDate2.startDate,
          endDate = _this$state$eventDate2.endDate;

      if (fullDay) {
        return MINUTES_PER_DAY - TIMEPICKER_INTERVAL;
      }

      return SimpleDate.equals(startDate, endDate) ? MINUTES_PER_DAY - 2 * TIMEPICKER_INTERVAL : MINUTES_PER_DAY - TIMEPICKER_INTERVAL;
    }
  }, {
    key: "getTimePickerMinValue",
    value: function getTimePickerMinValue() {
      var _this$state$eventDate3 = this.state.eventDates,
          fullDay = _this$state$eventDate3.fullDay,
          startDate = _this$state$eventDate3.startDate,
          endDate = _this$state$eventDate3.endDate,
          startTime = _this$state$eventDate3.startTime;

      if (fullDay) {
        return 0;
      }

      return SimpleDate.equals(startDate, endDate) ? startTime + TIMEPICKER_INTERVAL : 0;
    }
  }, {
    key: "renderTimezone",
    value: function renderTimezone() {
      var timezone = this.state.eventDates.timezone;
      return _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('timezone')
        })
      }, _react.default.createElement(_UISelect.default, {
        options: (0, _groupsToSelectOpts.default)((0, _getTimezoneGroups.default)()),
        value: timezone,
        onChange: this.handleTimeZoneChange
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          validation = _this$props7.validation,
          eventTitle = _this$props7.eventTitle,
          eventDetails = _this$props7.eventDetails,
          eventLocation = _this$props7.eventLocation,
          allGates = _this$props7.allGates;
      var _this$state$eventDate4 = this.state.eventDates,
          startDate = _this$state$eventDate4.startDate,
          fullDay = _this$state$eventDate4.fullDay,
          endDate = _this$state$eventDate4.endDate,
          startTime = _this$state$eventDate4.startTime,
          endTime = _this$state$eventDate4.endTime;
      return _react.default.createElement("div", {
        className: "event-selector"
      }, _react.default.createElement(_SimpleTextInputWithValidation.default, {
        className: "event-selector__event-title",
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('eventTitle')
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(validation, 'eventTitle'),
        name: "eventTitle",
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.eventTitleState, MAX_LENGTH_TITLE),
        value: eventTitle || '',
        placeholder: _I18n.default.text(this.langKey('eventTitlePlaceholder')),
        onChange: this.handleTitledChange,
        onBlur: this.handleTitleBlur,
        required: true
      }), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('startDate')
        })
      }, _react.default.createElement(_UIFlex.default, {
        className: "m-top-2",
        wrap: "wrap"
      }, _react.default.createElement(_UIBox.default, {
        grow: 1,
        className: "m-right-4"
      }, _react.default.createElement(_UIDatePicker.default, {
        minValue: SimpleDate.now(),
        onChange: this.handleStartDateChange,
        defaultValue: startDate,
        value: startDate
      })), _react.default.createElement(_UIBox.default, {
        grow: 1
      }, _react.default.createElement(_UITooltip.default, {
        disabled: !fullDay,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('error.fullDayTooltip')
        })
      }, _react.default.createElement(_UITimePicker.default, {
        disabled: fullDay,
        interval: TIMEPICKER_INTERVAL,
        value: startTime,
        defaultValue: startTime,
        maxValue: this.getTimePickerMaxValue(),
        onChange: this.handleStartTimeChange,
        defaultOpen: false
      }))))), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('endDate')
        })
      }, _react.default.createElement(_UIFlex.default, {
        className: "m-top-2",
        wrap: "wrap"
      }, _react.default.createElement(_UIBox.default, {
        grow: 1,
        className: "m-right-4"
      }, _react.default.createElement(_UIDatePicker.default, {
        defaultValue: endDate,
        minValue: startDate,
        onChange: this.handleEndDateChange,
        value: endDate
      })), _react.default.createElement(_UIBox.default, {
        grow: 1
      }, _react.default.createElement(_UITooltip.default, {
        disabled: !fullDay,
        title: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('error.fullDayTooltip')
        })
      }, _react.default.createElement(_UITimePicker.default, {
        disabled: fullDay,
        defaultValue: endTime,
        value: endTime,
        minValue: this.getTimePickerMinValue(),
        interval: TIMEPICKER_INTERVAL,
        onChange: this.handleEndTimeChange,
        defaultOpen: false
      }))))), _react.default.createElement(_UIFormControl.default, null, _react.default.createElement(_UICheckbox.default, {
        checked: fullDay || false,
        onChange: this.handleFullDayChange
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.langKey('fullDay')
      }))), this.renderTimezone(), _react.default.createElement(_SimpleTextInputWithValidation.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('eventLocation')
        }),
        isInvalid: !(0, _ValidationUtils.isValid)(validation, 'eventTitle'),
        name: "eventLocation",
        invalidMessage: (0, _ValidationUtils.maybeShowInvalidMessage)(validation.eventLocation, MAX_LENGTH_LOCATION),
        value: eventLocation || '',
        placeholder: _I18n.default.text(this.langKey('locationPlaceholder')),
        onChange: this.handleLocationChange,
        required: false
      }), _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: this.langKey('details')
        })
      }, _react.default.createElement(_RichTextEditor.default, {
        className: "calendar-content-rich-text-editor",
        id: "calendar-details",
        contents: eventDetails || '',
        disabled: false,
        onChange: this.handleDetailsChange,
        gates: allGates
      })));
    }
  }]);
  return EventSelector;
}(_react.PureComponent);

exports.default = EventSelector;
module.exports = exports.default;